import {
  Box, Container, Skeleton, Typography,
} from '@mui/material'
import CardWithSpace from '../../../components/Cards/CardWithSpace'
import TitleWithIcon from '../../../components/Cards/helpers/TitleWithIcon'

import SvgIconSize from '../../../components/Cards/helpers/SvgIconSize'
import { styles } from './ActionHistoryCardList'

const ActionHistoryCardListSkeleton = ({ size = 1 }) => (
  <Container maxWidth={false} sx={styles.container} data-testid="inboxListContainer">
    {[...new Array(size)].map((notification) => (
      <CardWithSpace
        key={notification}
        customStyles={{ ...styles.card, backgroundColor: 'transparent' }}
        data-testid="Inbox-item"
      >
        <Box sx={styles.cardsContainer}>
          <Box sx={styles.cardHeader}>
            <TitleWithIcon
              title={(
                <Box sx={styles.cardTitle}>
                  <Typography variant="body1" sx={styles.cardTitleName}>
                    <Box component="span" sx={styles.cardTitleCode}>
                      <Skeleton variant="text" width={120} />
                    </Box>
                  </Typography>
                </Box>
                   )}
              icon={<SvgIconSize icon={<Skeleton variant="rectangular" />} size="sm" />}
              customStyle={styles.stackFlex}
            />
          </Box>
          <Skeleton variant="text" width={200} />

          <Box sx={styles.cardInfoContainer}>

            <Box sx={styles.rowFlex}>
              <TitleWithIcon
                title={(
                  <Box sx={styles.requestedOnContainer}>
                    <Typography variant="body1" sx={styles.requestedOnDate}>
                      <Skeleton variant="text" width={120} />

                    </Typography>
                  </Box>
                   )}
                icon={(
                  <SvgIconSize icon={<Skeleton variant="rectangular" />} size="sm" />
              )}
                customStyle={styles.iconWithText}
              />
            </Box>

            <Box sx={styles.rowFlex}>
              <TitleWithIcon
                title={(
                  <Box sx={styles.requestedOnContainer}>
                    <Typography variant="body1" sx={styles.requestedOnDate}>
                      <Skeleton variant="text" width={120} />
                    </Typography>
                  </Box>
                   )}
                icon={(
                  <SvgIconSize icon={<Skeleton variant="rectangular" />} size="sm" />
              )}
                customStyle={styles.iconWithText}
              />
            </Box>
            <Box sx={styles.rowFlex}>
              <TitleWithIcon
                title={(
                  <Box sx={styles.requestedOnContainer}>
                    <Typography variant="body1" sx={styles.requestedOnDate}>
                      <Skeleton variant="text" width={120} />
                    </Typography>
                  </Box>
                   )}
                icon={(
                  <SvgIconSize icon={<Skeleton variant="rectangular" />} size="sm" />
              )}
                customStyle={styles.iconWithText}
              />
            </Box>
          </Box>
        </Box>
      </CardWithSpace>
    ))}
  </Container>
)

export default ActionHistoryCardListSkeleton
